/** Below this width the dock lifts out of the grid and overlays the page.
 *  The rule that lifts it is the kit's (`DockPanel` positions itself absolute
 *  under this number); this layout collapses its grid to one column and hides
 *  the resize handle at the same one. `frame.test.tsx` pins the two together,
 *  so a kit that moves its breakpoint fails here, not on a laptop. */
export const DOCK_OVERLAY_MAX_WIDTH_PX = 1180;
